import {GetBrigadesChips} from "./Balance";


class DispetcherCenter{
    constructor(brigades) {
        this.brigades = brigades;
        this.brigadesChips = 0;
        this.additionalChips = 0;
    }
    renew(){
        this.brigadesChips = GetBrigadesChips("dispetcher") * this.brigades;
    }
    copy(dispetcher){
        this.brigades = dispetcher.brigades;
        this.brigadesChips = dispetcher.brigadesChips;
        this.additionalChips = dispetcher.additionalChips;
    }
}

export default DispetcherCenter;